import React from "react";

const ArrowLeftIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.56945 19.32C9.37945 19.32 9.18945 19.25 9.03945 19.1L2.96945 13.03C2.67945 12.74 2.67945 12.26 2.96945 11.97L9.03945 5.9C9.32945 5.61 9.80945 5.61 10.0995 5.9C10.3895 6.19 10.3895 6.67 10.0995 6.96L4.55945 12.5L10.0995 18.04C10.3895 18.33 10.3895 18.81 10.0995 19.1C9.95945 19.25 9.75945 19.32 9.56945 19.32Z"
        fill="#292D32"
      />
      <path
        d="M20.4999 13.25H3.66992C3.25992 13.25 2.91992 12.91 2.91992 12.5C2.91992 12.09 3.25992 11.75 3.66992 11.75H20.4999C20.9099 11.75 21.2499 12.09 21.2499 12.5C21.2499 12.91 20.9099 13.25 20.4999 13.25Z"
        fill="#292D32"
      />
    </svg>
  );
};

export default ArrowLeftIcon;
